import { appointmentApi } from './appointment.api';

export const appointmentActions = {
  async getAppointments({ commit }, payload) {
    try {
      commit('GET_APPOINTMENTS_LOADING');
      const response = await appointmentApi.getAppointments(payload);
      commit('GET_APPOINTMENTS_SUCCESS', response.data);
      return response;
    } catch (error) {
      commit('GET_APPOINTMENTS_ERROR', error.response);
    }
  },
  async getAppointment({ commit }, id) {
    try {
      commit('GET_APPOINTMENT_LOADING');
      const response = await appointmentApi.getAppointment(id);
      commit('GET_APPOINTMENT_SUCCESS', response.data);
      return response;
    } catch (error) {
      commit('GET_APPOINTMENT_ERROR', error.response);
    }
  },
  async updateAppointment({ commit }, { id, body }) {
    try {
      commit('UPDATE_APPOINTMENT_LOADING');
      const response = await appointmentApi.updateAppointment(id, body);
      commit('UPDATE_APPOINTMENT_SUCCESS', response.data);
    } catch (error) {
      commit('UPDATE_APPOINTMENT_ERROR', error.response);
    }
  },
};
